const capitaliseFirstLetterInWord = (strObj: string): string => {
  return strObj?.charAt(0).toUpperCase() + strObj?.slice(1)?.toLowerCase();
};

export const capitaliseFirstLetterInEachWord = (sentence: string): string =>
  sentence?.split(' ')?.map(capitaliseFirstLetterInWord).join(' ');

export const capitaliseWord = (sentence: string): string =>
  sentence?.toUpperCase();
